import { Device, toDevice } from '@peloton/browser/identify';
import { useAppDownload } from '@members/copy/copy.generated';
import type { CopyIDs } from '@members/copy/CopyIDs';
import { AppDownload } from '@members/copy/models.generated/AppDownload';
import { Links } from '@members/copy/models.generated/Links';

const map = {
  [Device.IOS]: AppDownload.IOS,
  [Device.Android]: AppDownload.Android,
};

export const toDownloadAppsProps = (device?: string) => ({
  id: device ? Links.GetTheApp : Links.GetApps,
  ...(device ? { values: { device } } : {}),
});

export const toDeviceNameId = (): CopyIDs<typeof AppDownload> => {
  const deviceType = toDevice();
  // @ts-expect-error (TS7053): Element implicitly has an 'any' type because expression of type 'Device' can't be used to index type '{ IOS: "iOS"; Android: "android"; }'.
  return map[deviceType];
};

export const useMaybeAppDownload = (id?: CopyIDs<typeof AppDownload>) => {
  const idOrDefault = id ?? AppDownload.Android;
  const device = useAppDownload(idOrDefault);
  return id ? device : '';
};
